<ng-container *ngIf="!this.isLandingPageFooter">
    <div *ngIf="!this.isCloudAcademy" class="get-in-touch text-center">
        <div class="get-in-touch__inner">
            <div class="get-in-touch__content-wrapper">
                <div class="get-in-touch__content">
                    <h2 class="get-in-touch__header">Questions?</h2>
                    <ng-container *ngIf="!showHRConnect && !showTwic">
                        <p class="get-in-touch__text">
                            <span class="get-in-touch__text--lead">Candidates: </span>
                            For high level answers to your benefits questions, you can contact our healthcare navigation
                            support team at Included Health at 1(833) 201-1471.
                        </p>
                        <p class="get-in-touch__text">
                            <span class="get-in-touch__text--lead">Current employees: </span>
                            For detailed benefits information, visit us on the Loop.
                        </p>
                        <a
                            class="btn btn-secondary"
                            href="https://theloop.paloaltonetworks.com/loop/ls/content/5862341181308928/u-s-"
                            target="_blank"
                            >U.S. Benefits Loop</a
                        >
                        <mat-accordion>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header collapsedHeight expandedHeight>
                                    <mat-panel-title>I require further assistance.</mat-panel-title>
                                </mat-expansion-panel-header>
                                <p class="mb-0">
                                    If you have a specific request or question, please reach out to the US Benefits Team
                                    via a <a href="mailto:hrconnect@paloaltonetworks.com">HRConnect ticket</a> or email
                                    <br /><a href="mailto:usbenefits@paloaltonetworks.com"
                                        >usbenefits&#64;paloaltonetworks.com</a
                                    >
                                </p>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </ng-container>
                    <ng-container *ngIf="showHRConnect">
                        <p class="get-in-touch__text get-in-touch__text--lead">
                            We love to talk. For general questions relating to life at Palo Alto Networks, contact our
                            HR team.
                        </p>
                        <a class="btn btn-secondary mb-0" href="mailto:HRConnect@paloaltonetworks.com"
                            >Contact HRConnect</a
                        >
                    </ng-container>
                    <ng-container *ngIf="showTwic">
                        <p class="get-in-touch__text get-in-touch__text--lead">
                            We love to talk. The thing is, you’ll get answers quicker if you go directly to Forma.
                        </p>
                        <p class="get-in-touch__text">
                            Reach out to Forma for any questions regarding your FLEXBenefits account/balance, item
                            eligibility, and reimbursement statuses. You can reach Forma's member experience team by
                            emailing support&#64;joinforma.com or by using the live-chat feature directly on your Forma
                            account (via Okta).
                        </p>
                        <a
                            class="btn btn-secondary"
                            href="https://paloaltonetworks.okta.com/app/UserHome"
                            target="_blank"
                            >Contact Forma</a
                        >
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-wrapper text-center">
        <footer *ngIf="pages$ | async as _pages" class="site-footer container">
            <div class="row">
                <div class="offset-lg-1 col-md-12 col-lg-10 d-flex align-content-center justify-content-center">
                    <div class="footer-brand">
                        <ng-container *ngIf="!isCloudAcademy">
                            <img
                                alt="FlexBenefits Logo"
                                class="footer__logo"
                                src="assets/img/flexbenefits-logo-black.svg" />
                        </ng-container>
                        <ng-container *ngIf="isCloudAcademy">
                            <img alt="Cloud Academy Logo" class="footer__logo" src="assets/img/cloud-header-logo.png" />
                        </ng-container>
                    </div>
                </div>
                <div
                    *ngIf="!isCloudAcademy"
                    class="col-md-12 d-flex align-content-center justify-content-center footer-menu-wrapper">
                    <ul class="d-flex">
                        <ng-container *ngFor="let page of _pages">
                            <li
                                *ngIf="
                                    page.meta.showFooterBar == '\'true\'' ||
                                    page.meta.showFooterBar == true ||
                                    page.meta.showFooterBar == 'true'
                                ">
                                <ng-container *ngIf="page.meta.redirect">
                                    <a href="{{ page.meta.redirect }}" target="_blank">{{ page.name }}</a>
                                </ng-container>
                                <ng-container *ngIf="!page.meta.redirect">
                                    <a
                                        [routerLink]="
                                            page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url
                                        "
                                        >{{ page.name }}</a
                                    >
                                </ng-container>
                            </li>
                        </ng-container>
                        <li>
                            <a
                                aria-label="Link to Cookie Policy"
                                href="//policy.cookiereports.com/622b1d50-en-gb.html"
                                target="_blank"
                                >Cookie Policy</a
                            >
                        </li>
                        <li>
                            <a
                                aria-label="Link to Cookie Policy"
                                href="//policy.cookiereports.com/622b1d50-en-gb.html"
                                target="_blank"
                                >Do Not Sell or Share My Personal Information</a
                            >
                        </li>
                    </ul>
                </div>
                <div class="offset-lg-2 col-md-12 col-lg-8 d-flex align-content-center justify-content-center">
                    <ng-container *ngIf="!isCloudAcademy">
                        <p class="disclaimer">
                            Please note that nothing on this website constitutes or implies a right to any benefits
                            listed here. In the event that content on this site is different from what is found in the
                            plan documents governing any and all of these offerings, the plan documents will take
                            priority over the content on this site.
                        </p>
                    </ng-container>
                </div>
                <div class="col-md-12">
                    <p class="copyright">
                        <span [innerHTML]="copyright"></span>
                    </p>
                </div>
            </div>
        </footer>
    </div>
</ng-container>
